import { QueryClient } from "@tanstack/react-query";
import { toast } from "@/stores/toastStore";
import { reportError } from "@/utils/errorReporter";
import { ApiRequestError } from "./api";
import { onSessionChange, SessionChangedError } from "./sessionLifecycle";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        if (error instanceof SessionChangedError) return;
        const msg = error instanceof Error ? error.message : "Něco se pokazilo";
        toast.error(msg);
        if (error instanceof ApiRequestError && error.status >= 400 && error.status < 500) return;

        reportError({
          severity: "error",
          errorType: error instanceof Error ? error.name : "MutationError",
          errorMessage: msg,
          errorStack: error instanceof Error ? error.stack : undefined,
          tags: { source: "react-query-mutation" },
          extra: error instanceof ApiRequestError ? { status: error.status, details: error.details } : undefined,
        });
      },
    },
  },
});

onSessionChange(() => {
  void queryClient.cancelQueries();
  queryClient.clear();
});
